import createLucideIcon from '../createLucideIcon';

const PauseCircle = createLucideIcon('PauseCircleIcon', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['line', { x1: '10', y1: '15', x2: '10', y2: '9', key: '2cxng6' }],
  ['line', { x1: '14', y1: '15', x2: '14', y2: '9', key: 'wsglx2' }],
]);

export default PauseCircle;
